import { render, staticRenderFns } from "./CommissionDetails.vue?vue&type=template&id=0d9503c3&scoped=true"
import script from "./CommissionDetails.vue?vue&type=script&lang=js"
export * from "./CommissionDetails.vue?vue&type=script&lang=js"
import style0 from "./CommissionDetails.vue?vue&type=style&index=0&id=0d9503c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9503c3",
  null
  
)

export default component.exports